// ==================================================================================
// Digital Approval System (DAS) - Reports Service
// ==================================================================================
// Axios calls for the Reports module — the Workflow Summary dashboard (U6)
// under My Reports.
// ==================================================================================

import { axiosClient } from '../../client/axiosClient';
import { ApiResponse } from '../../types/common.types';
import { UserWorkflowSummaryDto } from '../../types/das/reports.types';
import { reportsEndpoints } from '../../endpoints/das/reports.endpoints';

/**
 * Reports service
 */
export const reportsService = {
  /**
   * Workflow Summary dashboard (U6) — all-time snapshot, no query params.
   */
  getUserWorkflowSummary: async (): Promise<UserWorkflowSummaryDto> => {
    const response = await axiosClient.get<ApiResponse<UserWorkflowSummaryDto>>(
      reportsEndpoints.getUserWorkflowSummary()
    );
    return response.data.data;
  },
};
